export default __webpack_public_path__ + "static/12-09857c68aeb3851f286e77d0cc2e5999.jpg";